module.exports = __webpack_public_path__ + "static/media/pager.2b1e2891.svg";